// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"R0-z","subtitle":"S0-z","wrapper":"T0-z","leftArrow":"U0-z","rightArrow":"V0-z"};